import React from 'react'
import styled from 'styled-components'
import { TextContainer } from '../../styles/globalStyles'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { addToCart } from '../../redux/feature/cartSlice'
import { useDispatch } from 'react-redux'
import {FoodTag} from '@styled-icons/boxicons-regular/FoodTag'
import {Edit} from '@styled-icons/boxicons-regular/Edit'
import {b} from '../../styles/variables'

export const AVAILS= {
  1:"Breakfast",
  2:"Lunch",
  3:"Snacks",
  4:"Dinner"
}

function MenuCard({menu, id, params, onEditClick, isAdmin}) {
   const [isHovering,setIsHovering]= useState(false)
   const navigate = useNavigate()
   const dispatch = useDispatch()
   
   const handleAddToCart = (menu) => {
    dispatch(addToCart([menu]));    
    navigate("/cart")
  };

  const handleEditClick = (e) => {
    e.stopPropagation()
    if (onEditClick && isAdmin) {
      onEditClick(menu)
    }
  }
   
  return (
    <CardContainer id={id} onMouseEnter={()=>setIsHovering(true)} onMouseLeave={()=>setIsHovering(false)}>
      <FoodSourceIndicator source={menu?.food_source}>
        <FoodTag size={18} color={menu?.food_source==="VEG" ? "#22c55e" : "#ef4444"}/>
      </FoodSourceIndicator>
      
      <CardMain>
        <CardHeader>
          <FoodNameRow>
            <FoodName>{menu?.food_name}</FoodName>
            {isAdmin && (
              <EditIcon size={18} onClick={handleEditClick} />
            )}
          </FoodNameRow>
          {menu?.food_description && (
            <FoodDescription>{menu?.food_description}</FoodDescription>
          )}
        </CardHeader>
        
        <CardMeta>
          <VendorName>{menu?.vendor?.vendor_name}</VendorName>
          {menu.availabilities.length !== 0 && (
            <AvailabilityRow>
              {menu.availabilities?.map((item, index) => (
                <AvailBadge key={index}>{AVAILS[item]}</AvailBadge>
              ))}
            </AvailabilityRow>
          )}
        </CardMeta>
      </CardMain>
      
      <CardActions>
        <PriceTag>
          <PriceLabel>Price</PriceLabel>
          <PriceValue>{menu?.food_price}</PriceValue>
        </PriceTag>
        <AddButton onClick={() => handleAddToCart(menu)}>
          Add to Plate
        </AddButton>
      </CardActions>
    </CardContainer>
  )
}

export default MenuCard

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 120px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #f4f4f5;
  border-radius: 14px;
  margin-bottom: 1.2rem;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover, &:active {
    border-color: transparent;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  }

  @media ${b.mobile}{
    flex-direction: column;
    border-radius: 12px;
  }
`

const FoodSourceIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  flex-shrink: 0;
  background: ${({source}) => source === "VEG" ? "rgba(34, 197, 94, 0.06)" : "rgba(239, 68, 68, 0.06)"};
  border-right: 1px solid #f4f4f5;

  @media ${b.mobile}{
    display: none;
  }
`

const CardMain = styled.div`
  flex: 1;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.6rem;
  min-width: 0;
`

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`

const FoodNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FoodName = styled.h3`
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e1e2d;
  margin: 0;
  overflow-wrap: break-word;
  word-break: break-word;
`

export const EditIcon = styled(Edit)`
  cursor: pointer;
  color: #a1a1aa;
  flex-shrink: 0;
  transition: all 0.2s ease;
  padding: 8px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 8px;
  -webkit-tap-highlight-color: transparent;
  
  &:hover, &:active {
    color: #F7707D;
    background: rgba(247, 112, 125, 0.08);
  }
`

const FoodDescription = styled.p`
  font-size: 1.2rem;
  color: #71717a;
  font-weight: 400;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const CardMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const VendorName = styled.span`
  font-size: 1.2rem;
  color: #a1a1aa;
  font-weight: 500;
`

const AvailabilityRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

const AvailBadge = styled.span`
  font-size: 1rem;
  background: #f4f4f5;
  color: #52525b;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 500;
`

const CardActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.4rem 2rem;
  gap: 0.8rem;
  border-left: 1px solid #f4f4f5;
  flex-shrink: 0;
  min-width: 140px;

  @media ${b.mobile}{
    flex-direction: row;
    justify-content: space-between;
    border-left: none;
    border-top: 1px solid #f4f4f5;
    padding: 1rem 1.6rem;
    min-width: auto;
  }
`

const PriceTag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media ${b.mobile}{
    flex-direction: row;
    gap: 6px;
  }
`

const PriceLabel = styled.span`
  font-size: 1rem;
  color: #a1a1aa;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

const PriceValue = styled.span`
  font-size: 2rem;
  font-weight: 800;
  color: #1e1e2d;

  @media ${b.mobile}{
    font-size: 1.6rem;
  }
`

export const AddButton = styled.button`
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  border-radius: 10px;
  padding: 10px 20px;
  min-height: 44px;
  border: none;
  color: white;
  font-weight: 600;
  font-size: 1.25rem;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  
  &:hover, &:active { 
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(247, 112, 125, 0.35);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(247, 112, 125, 0.2);
  }

  @media ${b.mobile}{
    padding: 10px 16px;
    font-size: 1.2rem;
  }
`

export const DetailsContainer = styled.div`
  display: flex;
  flex: 5;
  justify-content: space-between;
  padding: 0 15px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  margin-left: 3%;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: left;
  flex-direction: column;
  @media ${b.mobile}{
    font-size: 50%;
  }
`

export const FoodNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const DescriptionContainer = styled.div``

export const PriceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  div{
    font-weight: 200;
    font-size: 1.4rem;
  }
`

export const DetailWrapper=styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 1rem 0;
  height: 100%;
  width: 70%;
`;

export const VendorDetails = styled.div`
  display: flex;
  flex-direction: row;
  p{
    font-size: 1.2rem;  
  }
  @media ${b.mobile}{
   flex-direction: column;
  }
`;

export const AvailabilityWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  width: 100%;
  h6{
    font-size: 1rem;
  }
  @media ${b.mobile}{
    flex-direction: column;
    align-items: flex-start;
  }
`

export const HWrapper= styled.div`
  display: flex;
  width: 30%;
  justify-content: left;
  @media ${b.mobile}{
    width: 100%;
  }
`

export const FoodSource = styled.div``;

export const AvailabilityContainer=styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 1.2rem;
  font-weight: 100;
  p{
    padding: 0 0.3rem;
  }
  @media ${b.mobile}{
    font-weight: 200;
    font-size:1.1rem;
  }
`

export const OutputContainer=styled.div`
  display: flex;
  flex-direction: row;
`
